module.exports = new __parcel__URL__("back-btn.181e2be9.svg").toString();